import React from 'react';
import { Box, Typography } from '@mui/material';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Box sx={{ backgroundColor: 'white', border: '1px solid #ccc', padding: '10px', borderRadius: '8px' }}>
        <Typography variant="h6">{label}</Typography>
        {payload.map((data, index) => (
          <Typography key={index} variant="body2" color="textSecondary">
            {data.name}: {data.value}
          </Typography>
        ))}
      </Box>
    );
  }

  return null;
};

export default CustomTooltip;